import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ColDef } from 'ag-grid-community';

const CellStyle = () => {
  return {
    marginLeft: '1px',
    paddingTop: '4px',
    paddingBottom: '3px',
    marginBottom: '3px',
    marginRight: '5px',
  };
};

@Injectable({ providedIn: 'root' })
export class DriverImportColumns {
  constructor(private translations: TranslateService) {}

  public columnDefinitions: ColDef[] = [
    {
      headerName: this.translations.instant('DRIVER_IMPORT.jobId'),
      field: 'jobId',
      colId: 'jobId',
      filter: true,
      cellStyle: CellStyle,
      width: 280,

      filterParams: { clearButton: true },
    },
    {
      headerName: this.translations.instant('DRIVER_IMPORT.updateType'),
      field: 'updateType',
      colId: 'updateType',
      filter: true,
      cellStyle: CellStyle,
      width: 170,
      filterParams: { clearButton: true },
    },
    {
      headerName: this.translations.instant('DRIVER_IMPORT.jobStatus'),
      field: 'jobStatus',
      colId: 'jobStatus',
      filter: true,
      cellStyle: CellStyle,
      cellRenderer: 'importStatusRenderer',
      width: 135,
      suppressSizeToFit: true,
    },
    {
      headerName: this.translations.instant('DRIVER_IMPORT.createdAt'),
      field: 'createdAt',
      colId: 'createdAt',
      filter: 'agDateColumnFilter',
      cellStyle: CellStyle,

      filterParams: { browserDatePicker: true, clearButton: true },
      width: 180,
    },
    {
      headerName: this.translations.instant('DRIVER_IMPORT.completedTime'),
      field: 'completedTime',
      colId: 'completedTime',
      filter: 'agDateColumnFilter',
      cellStyle: CellStyle,

      filterParams: { browserDatePicker: true, clearButton: true },
      width: 180,
    },
    {
      headerName: this.translations.instant('DRIVER_IMPORT.processedFile'),
      field: 'processedFile',
      colId: 'processedFile',
      cellStyle: CellStyle,
      cellRenderer: 'processedFileRenderer',
      width: 120,
      suppressSizeToFit: true,
      filter: true,
      filterParams: { clearButton: true },
    },
    {
      headerName: this.translations.instant('DRIVER_IMPORT.importedBy'),
      field: 'importedBy',
      colId: 'importedBy',
      filter: true,
      cellStyle: CellStyle,

      width: 120,
      filterParams: { clearButton: true },
    },
    {
      headerName: this.translations.instant('DRIVER_IMPORT.actions'),
      field: 'actions',
      colId: 'actions',
      cellRenderer: 'viewDetailRenderer',
      cellStyle: CellStyle,
      width: 180,
      suppressSizeToFit: true,
    },
  ];
}
